import { NEX_EXTRAS_PROCESS_CLEAR_STATE } from "./constants";
import { newExtrasProcessInitialState } from "./newExtrasProcess";

const clear = (state: any) => {
	Object.assign(state, newExtrasProcessInitialState());
};

const setNewExtras = (state: any, newExtras: any) => {
	state.newExtras = newExtras;
};

const setNewExtrasShoppingCartId = (state: any, shoppingCartId: string) => {
	state.shoppingCartId = shoppingCartId;
};

const setNewExtrasStatus = (state: any, status: string) => {
	state.status = status;
};

export default {
	[NEX_EXTRAS_PROCESS_CLEAR_STATE]: clear,
	setNewExtras,
	setNewExtrasShoppingCartId,
	setNewExtrasStatus
};
